const normalizeThreadTimestamp = (value) => {
  const normalized = String(value || '').trim();

  if (!normalized) {
    return null;
  }

  const parsed = Date.parse(normalized);

  if (!Number.isFinite(parsed)) {
    return null;
  }

  return normalized;
};

export default normalizeThreadTimestamp;
